module.exports = __webpack_public_path__ + "static/media/sorting.eda49e63.svg";